define([
	"dojo/_base/declare",
	"csi/datasheet/SubtypedDataSheet"
], function(declare, SubtypedDataSheet) {

	return declare(SubtypedDataSheet, {

		// view id that is going to be repeated per subtype
		subtypedViewId: "BatchSectionTestSpecs",

		// the name of the relation to the subtyped class
		relationToSubtypedClass: "Sections",

		// the name of the relation from the subtyped class to Subtype
		relationToSubtype: "Subtype",

		// the name of the class that has subtypes
		subtypedClassName: "FinalInspectionSection",

		// property used in the setViewNode function
		viewNodePropertyName: "urlRoot"

	});
});